// extracted by mini-css-extract-plugin
export default {"tab":"bottomTab_tab__IQMgj","isActive":"bottomTab_isActive__AEVsn","close":"bottomTab_close__T5zbe"};